import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

const Foot = ({ context }) => {
    
    const ctxGlobal 	= () => context.global;
	const global 		= ctxGlobal();
	
	const posts = () => context.posts;
    const post = posts()[0];
    
	let formStep 		= 0; 
	
	function nextClick(evt) {
		evt.preventDefault();
		if (document.getElementById('input_1_1').value !== '' && document.getElementById('input_1_3').value !== '' && document.getElementById('input_1_5').value !== '') {
			evt.currentTarget.closest('.scope-footer-subscribe').classList.add('state-step-1');
		}
	}
	  		    
    if (global && post) {
		
		function handleMouseOver() {
			document.documentElement.classList.add('state-reverse-cursor');
		}
		
		function handleMouseOut() {
			document.documentElement.classList.remove('state-reverse-cursor');
		}
					
		if (global.json === null) {
		
			context.getGlobal(window.location.origin + '/wp-json/castran/v1/global');
		
		}
		
		if (global.json !== null) {  

			return (
				
				<div className="c-footer scope-reverse" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
					<div className="l-content l-content--fixed-width">
			    		<div className="l-grid">
			    			
			    			{post.show_footer === true &&
				    			
				    			<>
				    		
					    			<div className="l-grid__col c-page__block"></div>
					    			{global.json.contact_heading && global.json.contact_text &&
						    			<div className="l-grid__col c-page__block c-page__block--l-space">
						    				<h3 className="c-paragraph c-paragraph--xlarge c-paragraph--small-space" dangerouslySetInnerHTML={{__html:global.json.contact_heading}}></h3>
						    				<div className="scope-text scope-text--xlarge" dangerouslySetInnerHTML={{__html:global.json.contact_text}}></div>
						    			</div>
						    		}
						    		{global.json.locations.length > 0 &&
							    		<>
							    			{global.json.locations.map((location,i) =>
				    							{
					    							if (location.email) {
						    							return (	
									    					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-3-12 u-m-show c-page__block c-page__block--l-space">
									    						<div className="scope-text" dangerouslySetInnerHTML={{__html:'<h3>' + location.heading + '<h3>' + location.text + '<p><a href="mailto:' + location.email + '">' + location.email + '</a></p>'}}></div>
											    			</div>
									    				)
					    							} else {
								    					return (	
									    					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-3-12 u-m-show c-page__block c-page__block--l-space">
									    						<div className="scope-text" dangerouslySetInnerHTML={{__html:'<h3>' + location.heading + '<h3>' + location.text}}></div>
											    			</div>
									    				)
								    				}
								    			}
								    		)}	
							    		</>	    			
					    			}
					    			{global.json.sub_form && global.json.sub_heading &&
						    			<div className="l-grid__col l-grid__col--l-9-12 c-page__block c-page__block--l-space">
						    				<h3 className="c-paragraph c-paragraph--xlarge c-paragraph--space" dangerouslySetInnerHTML={{__html:global.json.sub_heading}}></h3>
						    				<div className={'scope-footer-subscribe state-step-' + formStep}>
						    					<GravityForm
													backendUrl={document.location.origin + '/wp-json/castran/v1/form'}
													formID={global.json.sub_form}
												/>
												<div className="faux-buttons">
													{formStep === 0 &&
														<a href="#" className="next" onClick={nextClick}>Next</a>
													}
												</div>
						    				</div>
						    			</div>
					    			}
					    			<div className="l-grid__col c-page__block c-page__block--l-space">
					    				<div className="c-footer__social">
							    			<h3 className="c-footer__social__heading c-paragraph c-paragraph--xlarge c-paragraph--space" dangerouslySetInnerHTML={{__html:'Connect with us on social'}}></h3>
							    			<p className="c-footer__social__link" dangerouslySetInnerHTML={{__html:'<a href="' + global.json.instagram + '" target="_blank">Instagram</a>'}}></p>
							    			<p className="c-footer__social__link" dangerouslySetInnerHTML={{__html:'<a href="' + global.json.linkedin + '" target="_blank">LinkedIn</a>'}}></p>
							    			<p className="c-footer__social__link" dangerouslySetInnerHTML={{__html:'<a href="' + global.json.facebook + '" target="_blank">Facebook</a>'}}></p>
							    		</div>
					    			</div>
					    			<div className="l-grid__col">
					    				<div className="c-rule"></div>
					    			</div>
					    			
					    		</>
					    		
				    		}
				    		
			    			<div className="l-grid__col">
			    				<div className="c-footer__foot">
			    					<div>
			    						<p className="c-paragraph c-paragraph--small c-paragraph--faded" dangerouslySetInnerHTML={{__html:'CASTRAN TM PTY LTD © ' + new Date().getFullYear()}}></p>
			    					</div>
			    					<div>
			    						<p className="c-paragraph c-paragraph--small c-paragraph--faded"><span dangerouslySetInnerHTML={{__html:'<span class="u-m-show u-m-show--inline"><a href="https://latitude.com.au" target="_blank">Site by Latitude</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>'}}></span><Link to={global.json.privacy_policy_url}>Privacy</Link><span dangerouslySetInnerHTML={{__html:' / '}}></span><Link to={global.json.disclaimer_url}>Disclaimer</Link></p>
			    					</div>
			    				</div>
							</div>
				    	</div>
				    </div>
				</div>
				
			)
				
		} else {
			
			return null;
			
		}
	    
    
    } else {
	    
	    return null;
	    
    }

}
export default WithConsumer(Foot);